import { AppLogo } from '@parcel/ui/app-logo';
import { Plug } from 'lucide-react';
import * as React from 'react';
import { logoUrl } from '../lib/logo.js';
import { catalogEntryAppLogo, catalogEntryLogoDomain } from '../lib/spec-connections.js';

export interface ConnectorGlyphProps {
  /** The catalog entry's `icon`, which is either a bundled app-logo name or a domain. */
  icon: string;
  name: string;
  /** Rendered size in px. */
  px: number;
  className?: string;
}

/**
 * A connector's own mark: the bundled app logo when there is one, the site's logo when there
 * is not, and a plug when neither loads.
 *
 * Bare on purpose. The connectors page wraps this in a tile because a card needs one; a menu
 * row does not, and the border made the row read as a nested control.
 */
export function ConnectorGlyph({ icon, name, px, className }: ConnectorGlyphProps) {
  const appLogoName = catalogEntryAppLogo(icon);
  const [failedSrc, setFailedSrc] = React.useState<string | null>(null);
  const src = logoUrl(catalogEntryLogoDomain(icon));

  // Monochrome marks (custom/MCP among them) paint with currentColor, so the
  // caller's text color is what keeps them visible in dark mode.
  if (appLogoName)
    return <AppLogo name={appLogoName} size={px} title={name} className={className} />;
  if (src && src !== failedSrc) {
    return (
      <img
        src={src}
        alt=""
        style={{ height: px, width: px }}
        className={className ?? 'object-contain'}
        onError={() => setFailedSrc(src)}
      />
    );
  }
  return <Plug className="size-4 text-muted-foreground" aria-hidden />;
}
